import type { McpServer } from '@modelcontextprotocol/sdk/server/mcp.js';
import { searchCollectionsV3Api } from '@repo/sdk';
import { z } from 'zod';

export function registerSearchCollections(server: McpServer): void {
  server.registerTool(
    'search_collections',
    {
      title: 'Search Cool Mate collections',
      description:
        'Search public Cool Mate collections by query. Returns matching collections with id, slug and title.',
      inputSchema: { query: z.string().min(1).max(200) },
    },
    async ({ query }) => {
      const { data } = await searchCollectionsV3Api(query);
      return {
        content: [{ type: 'text', text: JSON.stringify(data?.data ?? []) }],
      };
    },
  );
}
